import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { AddOnCustomize } from "./component";
import {
  selectedCfarIdSelector,
  fetchCfarQuotesCallStateSelector,
} from "../../../reducer";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../../rewards/reducer";
import {
  isCfarAvailableInChosenRoomProductSelector,
  hotelCfarQuoteFromChosenRoomProductSelector,
  cancellationPolicyFromChosenRoomProductSelector,
  isOptionSelectionCompleteSelector,
} from "../../../../shop/reducer";
import { IStoreState } from "../../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => {
  return {
    selectedCfarId: selectedCfarIdSelector(state),
    isCfarAvailable: isCfarAvailableInChosenRoomProductSelector(state),
    cfarQuote: hotelCfarQuoteFromChosenRoomProductSelector(state),
    cancellationPolicy: cancellationPolicyFromChosenRoomProductSelector(state),
    isOptionSelectionComplete: isOptionSelectionCompleteSelector(state),
    fetchCfarQuotesCallState: fetchCfarQuotesCallStateSelector(state),
    rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AddOnCustomizeConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedAddOnCustomize = withRouter(connector(AddOnCustomize));
